import { useContext } from 'react';

import CheckoutSessionsPaymentForm from '@/components/purchase/CheckoutSessionsPaymentForm';
import { subscribePurchaseErrors } from '@/components/purchase/utils/Purchase';
import usePurchaseBodyArgs from '@/components/Sisu/hooks/usePurchaseBodyArgs';

import { PreSignupFlowContext } from '../../PreSignupProvider';
import PaymentFormHeading from '../PaymentFormHeading';
import { SECOND_FREE_TRIAL_FLOW_NAME } from './constants';
import { Wrapper } from './styles';
import { PaymentFormModuleProps } from './types';

const secondFreeTrialPurchaseErrors = subscribePurchaseErrors.filter(v => v !== 'previously-trialed');

const PaymentFormModule = ({
	hideHeaderCost,
	onSuccessOverride,
	hidePaypal = false,
	isSecondFreeTrial = false,
	isVisible = false,
}: PaymentFormModuleProps) => {
	const { nextScreen, isCheckoutSessionsEnabled } = useContext(PreSignupFlowContext);
	const { freeTrial: isTrialPurchase } = usePurchaseBodyArgs({});

	function onSuccess() {
		if (onSuccessOverride) {
			onSuccessOverride();
			return;
		}
		nextScreen();
	}

	if (!isVisible) {
		return null;
	}

	return (
		<Wrapper role="alert" aria-live="polite">
			{!hideHeaderCost && <PaymentFormHeading isSecondFreeTrial={isSecondFreeTrial} hideOrderSummary />}
			<CheckoutSessionsPaymentForm
				flowName={SECOND_FREE_TRIAL_FLOW_NAME}
				plan="yearly"
				pageName="second_free_trial"
				hasFreeTrial={isTrialPurchase}
				isCheckoutSessionsEnabled={isCheckoutSessionsEnabled}
				endpoint="subscription"
				hidePaypal={hidePaypal}
				afterPurchaseSuccess={onSuccess}
				subscribePurchaseErrors={secondFreeTrialPurchaseErrors}
				showLegacyPurchaseTerms
			/>
		</Wrapper>
	);
};

export default PaymentFormModule;
